const PasswordInput = ({ value, onChange, placeholder, show, toggleShow }) => (
  <div style={{ position: "relative", marginBottom: "16px" }}>
    <input
      type={show ? "text" : "password"}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      style={{
        width: "100%",
        padding: "14px 44px 14px 16px",
        fontSize: "14px",
        borderRadius: "8px",
        border: "1px solid #e2e8f0",
        backgroundColor: "#f8fafc",
        outline: "none",
      }}
    />

    <span
      onClick={toggleShow}
      style={{
        position: "absolute",
        right: "14px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        color: "#64748b",
      }}
    >
      {show ? "🙈" : "👁️"}
    </span>
  </div>
);
export default PasswordInput;
